import type { FaireProductEntity } from "../../entity_types/product";

export const p_4jgmwqrkmx: FaireProductEntity = {
  token: "p_4jgmwqrkmx",
  type: "product",
  name: "Classic Mother Mary Necklace",
  brandToken: "b_2ki6r755",
  brandName: "JOY DRAVECKY JEWELRY",
  imageUrl:
    "https://cdn.faire.com/fastly/2b2d9954637a01f4960bd0be813027e2fdc881cfd54e8736fb944ea5b2e4f934.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/759e4034bcc99ceb4abaac06fca0d8718a9a3d6c12d028103acbc844538ca044.jpeg",
    "https://cdn.faire.com/fastly/0f91c8609475c0f8b7e2eabdc3a3a1ce39e1dcced1463058c033b65e30667d74.jpeg",
    "https://cdn.faire.com/fastly/be7e9b9f2afb09f817f11b7d96b74146cd22f7e085e953bbe64d08af959d15b0.jpeg",
    "https://cdn.faire.com/fastly/f191faab42d324e93ed264b24eb4d35b4c9a2b071cdc034ff446e06a0f92a001.jpeg",
    "https://cdn.faire.com/fastly/63cce2cc97e08df81e17c7b5da2e8353bbb2768418830a4ddd37466c6e12f8b9.jpeg",
    "https://cdn.faire.com/fastly/a2dbc9014ea54fcf08716b14c0f7d813adcaa6970ee4e193ff1b5b704cdc2fe1.jpeg",
    "https://cdn.faire.com/fastly/0c148fdd9b59481120c7ba98fa4fc53a9e8915670f9d8d632ccce3ffbe3c11b4.jpeg",
    "https://cdn.faire.com/fastly/638aa58a9bdbc254ebd8edf7d6390bb1bca16556e95c32e845d0e9f92bb394c8.jpeg",
  ],
  priceDollars: 105,
  description:
    "An iconic Joy Dravecky design, The Mother Mary is a luminous symbol of faith and style. Featuring a glowing mother of pearl center framed by sparkling baguette and round stones, this gold-finished pendant is made to shine—whether worn solo or layered.\n\nChain\n\n * Measurement: 18 Inch + 2 Inch Extender \n * Materials: 14k Gold Plated Over Brass \nCharm\n\n * Measurement: \n * Materials: 14k Gold Plated Over Brass / Genuine Mother of Pearl Shell / AAA Rated Cubic Zirconia Baguettes \nOverall\n\n * Care & Cleaning (recommended): Avoid All Water Types, Store In Dry Places, & Clean With Gold Jewelry Cleaner \n * Features: Adjustable \nLifetime Warranty / 30-Day Return Policy \n\nProcessing Time for This Product Is 1-2 Business Days Prior to Shipment.\n",
  tags: [],
  msrpDollars: 129,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:36.436Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
